import { render } from "./partener_list_page.vue?vue&type=template&id=d4be457c"
import script from "./partener_list_page.vue?vue&type=script&lang=js"
export * from "./partener_list_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__